
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa" [ngClass]="getIconClass()"></i><span class="ml-2">{{options.title}}</span></h4>
    <button *ngIf="!options.hideCloseButton" type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>
   

  <div class="modal-body">
    <div>
      <div class="font-weight-bold">{{options.header}}</div>
      <div class="mt-2" [innerHtml]="body"></div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn" [ngClass]="getDefaultButtonClass()" data-dismiss="modal" (click)="accept()">{{options.okText}}</button>
    <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">{{options.cancelText}}</button>
  </div>
</div>
</div>
